import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/clips/flexbar-protein-poster.jpg")